/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import * as React from 'react';

import { IEcommPageTitleViewProps } from './ecomm-page-title';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommPageTitleViewProps>}
 */
export class EcommPageTitleView extends React.PureComponent<IEcommPageTitleViewProps> {
    public render(): JSX.Element | null {
        const { title, enablePrimaryColour, className, TitleStyle, TitlePrimaryColour } = this.props;

        let resultStyle = `${className}` + ` ` + `${TitleStyle}`;

        if (enablePrimaryColour) {
            resultStyle = `${className}` + ` ` + `${TitlePrimaryColour}`;
        }

        return (
            <div className={resultStyle} id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                {title}
            </div>
        );
    }
}

export default EcommPageTitleView;
